// zIndex 取值标准
export const zIndexValue = {
    COMMON_BASE: 100,    // 基础值（高于大多数页面元素）100-999 低于所有抽屉
    DRAWER_OR_MODAL_BASE: 1000,      // 每层增量 模态框(Modal)抽屉 1000-2000
    MESSAGE_BASE: 3000,       // 3000-6000 消息层
    LOADING_BASE: 9000    // loading层 9000-
}

export const commonModalFormLayout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 19,
  },
};

// 业务本地存储key，项目退出需要销毁的key
export const globalLocalStorageCanDestroyKeys = {
  h5_oa_activeTab: '__h5_oa_activeTab__',
  h5_oa_detailRecord: '__h5_oa_detailRecord__'
}

export const deviceStautsColorsMap = new Map([
  ['运行', '#52b622'],
  ['空闲', '#f3b202'],
  ['离线', '#8a8a8a'],
  ['静机保持', '#0D89F7'],   // 等同于待机
  ['报警', '#F70000'],
  ['未知', '#8a8a8a'],
]);

export const deviceStautsDisc = ['运行', '空闲', '离线', '静机保持', '报警', '未知'];
export const AppVersionList = {
  'PREVIEW_ENV' : {
    code: 'PREVIEW_ENV',
    name:'免费版',
    includesApps: ['ISWAN-MES']
  },
  'Professional': {
    code: 'FACTORY_PremiumEdition',
    name:'尊享版',
    includesApps: ['ISWAN-MES','ISWAN-DEVICE','ISWAN-EHS']
  },
  // 'Professional_P': {
  //   name:'专业Pro版'
  // },
  'Enterprise': {
    code: 'Enterprise',
    name:'旗舰版',
    includesApps: ['ISWAN-MES','ISWAN-DEVICE','ISWAN-EHS','ISWAN-DATA-DECISION']
  },
}

export const getAppVersionConfig = (versionCode?: string) => {
  if (!versionCode) {
    return undefined;
  }
  const versionByKey = AppVersionList[versionCode as keyof typeof AppVersionList];
  if (versionByKey) {
    return versionByKey;
  }
  return Object.values(AppVersionList).find((item) => item.code === versionCode);
};

/** 产品全称 */
export const PRODUCT_FULL_NAME = 'Edatlink AI 智慧应用平台';
/** 系统标签名称 */
export const SYSTEM_TAG_NAME = '智能工厂';

/**
 * 获取带版本标识的产品标题，如：智能工厂-免费版
 * @param versionCode AppVersionList 中的 code
 * @returns 产品标题
 */
export const getProductVersionTitle = (versionCode?: string): string => {
  const version = getAppVersionConfig(versionCode);
  if (version) {
    return `${SYSTEM_TAG_NAME}-${version.name}`;
  }
  // 默认返回旗舰版
  return `${SYSTEM_TAG_NAME}-${AppVersionList.Enterprise.name}`;
};

export interface customThemesType {
  code: string;
  name: string;
  colors: string[];
  color: string;
  classname: string;
}
export const customThemes: customThemesType[] = [
  {
    code: 'blue',
    name: '蓝色主题',
    colors: ['#346AFD', '#88a7f3', '#346AFD'],
    color: '#ffffff',
    classname: 'custom-theme-blue'
  },
  {
    code: 'purple',
    name: '紫色主题',
    colors: ['#722ED1', '#b785f6', '#722ED1'],
    color: '#ffffff',
    classname: 'custom-theme-purple'
  },
  {
    code: 'red',
    name: '红色主题',
    colors: ['#F5222D','#fb8683', '#F5222D' ],
    color: '#ffffff',
    classname: 'custom-theme-red'
  },
  {
    code: 'orange',
    name: '橙色主题',
    colors: ['#FF7A45', '#fab798', '#FF7A45'],
    color: '#ffffff',
    classname: 'custom-theme-orange'
  },
  {
    code: 'cyan',
    name: '青色主题',
    colors: ['#08979C', '#52f8f1', '#5CDBD3'],
    color: '#ffffff',
    classname: 'custom-theme-cyan'
  },
  {
    code: 'black',
    name: '默认黑色',
    colors: ['#050000', '#838383', '#090909'],
    color: '#ffffff',
    classname: 'custom-theme-black'
  },
  {
    code: 'white',
    name: '默认亮色',
    colors: ['#ffffff', '#dddddd', '#fbfbfb'],
    color: '#000000',
    classname: 'custom-theme-white'
  },
];
